<template>
  <!-- modal Edit-->
  <b-modal
    id="modal-edit-password"
    cancel-variant="outline-secondary"
    ok-title="編輯"
    cancel-title="關閉"
    centered
    title="編輯密碼"
    @ok="handleEdit"
    :ok-disabled="false"
    :no-close-on-esc="force"
    :no-close-on-backdrop="force"
    :hide-header-close="force"
    :ok-only="force"
  >
    <validation-observer ref="passwordForm" #default="{ invalid }">
      <b-form>
        <validation-provider
          #default="{ errors }"
          name="此欄"
          vid="v_old_password"
          rules="required"
        >
          <b-form-group>
            <label for="old_password">現在的密碼:</label>
            <b-form-input
              id="old_password"
              type="password"
              placeholder="現在的密碼"
              :state="errors.length > 0 ? false : null"
              v-model="userInfo.old_password"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          name="此欄"
          vid="v_password"
          rules="required"
        >
          <b-form-group>
            <label for="password">密碼:</label>
            <b-form-input
              id="password"
              type="password"
              placeholder="密碼"
              v-model="userInfo.password"
              :state="errors.length > 0 ? false : null"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          name="此欄"
          vid="v_password_confirmation"
          rules="required"
        >
          <b-form-group>
            <label for="name">確認密碼:</label>
            <b-form-input
              type="password"
              v-model="userInfo.password_confirmation"
              placeholder="確認密碼"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { ref, onMounted } from "@vue/composition-api";
import store from "@/store";
import axiosIns from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BModal,
  BButton,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
  },
  props: {
    force: { type: Boolean, default: false },
  },
  data() {
    return {
      userInfo: { old_password: "", password: "", password_confirmation: "" },
      required,
    };
  },
  methods: {
    resetForm() {
      this.userInfo = {
        old_password: "",
        password: "",
        password_confirmation: "",
      };
    },
    hideModal() {
      this.$root.$emit("bv::hide::modal", "modal-edit-password", "#btnShow");
    },
    handleLogout() {
      //Request server to void the token
      axiosIns.get("/logout");
      localStorage.clear();
      // localStorage.setItem("isWarningShow", 1);
      //Reqired to login page
      //Show the success message
      this.$router.replace("/login").then(() => {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `成功`,
            icon: "CoffeeIcon",
            variant: "success",
            text: `您已成功退出！`,
          },
        });
      });
    },
    handleEdit(bvModalEvt) {
      bvModalEvt.preventDefault();
      axiosIns
        .post("/resetpassword", this.userInfo)
        .then((response) => {
          this.$bvModal.hide("modal-edit-password");
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CoffeeIcon",
              variant: "success",
              text: response.data.message,
            },
          });
          if (this.force) {
            this.$emit('success')
          } else {
            this.handleLogout();
          }
        })
        .catch((error) => {
          const message = error.response.data.message;
          var showMessage = "";
          var showMessage = message;
          if (typeof showMessage === "object") {
            showMessage = "";
            for (var key in message) {
              if (message.hasOwnProperty(key)) {
                showMessage += message[key] + "\n";
              }
            }
          }
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "CoffeeIcon",
              variant: "danger",
              text: showMessage,
            },
          });
        });
    },
  },
};
</script>

<style></style>
